import { render, staticRenderFns } from "./UnitInfo.vue?vue&type=template&id=12132151&scoped=true&"
import script from "./UnitInfo.vue?vue&type=script&lang=js&"
export * from "./UnitInfo.vue?vue&type=script&lang=js&"
import style0 from "./UnitInfo.vue?vue&type=style&index=0&id=12132151&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12132151",
  null
  
)

export default component.exports